import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import IconButton from 'components/atoms/IconButton';
import MbTooltip from 'components/atoms/MbTooltip';
import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  filterWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    alignItems: 'center',
    padding: '5px 15px',
    boxSizing: 'border-box',
    marginBottom: 20,
    backgroundColor: '#f6f6f9',
    borderRadius: '4px',
    '& > div': {
      margin: '3px 7px 5px 0',
    },
  },
  resetBtn: {
    margin: '0 !important',
    marginLeft: 'auto !important',
  },
}));

const FilterWrap = (props) => {
  const { handleOnReset, children, handleOnUpload } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx('mb-FilterWrap', classes.filterWrap)}>
      {children}
      {typeof handleOnUpload !== 'undefined' && (
        <IconButton onClick={handleOnUpload}>
          <Icon icon={'faUpload'} color="#4d5059" />
          {t('일괄등록')}
        </IconButton>
      )}
      {typeof handleOnReset !== 'undefined' && (
        <MbTooltip
          title={t('초기화')}
          className={classes.resetBtn}
          placement="right-start"
        >
          <IconButton onClick={handleOnReset}>
            <Icon icon={'faUndo'} color="#4d5059" />
            {t('초기화')}
          </IconButton>
        </MbTooltip>
      )}
    </div>
  );
};

export default FilterWrap;
